import { render, staticRenderFns } from "./DeleteTeamModal.vue?vue&type=template&id=3c94c345&scoped=true&"
import script from "./DeleteTeamModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94c345",
  null
  
)

export default component.exports